/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.ProductDevelopment {

    import fld = StageMembersRow.Fields;

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.registerEditor()
    export class StageMembersEditor extends _Ext.GridEditorBase<StageMembersRow> {
        protected getColumnsKey() { return "ProductDevelopment.StageMembers"; }
        protected getDialogType() { return StageMembersDialog; }
        protected getLocalTextPrefix() { return StageMembersRow.localTextPrefix; }

        protected form: StageMembersForm;
         
    }
}